export enum UserRole {
  ADMIN = 'ADMIN',
  FIELD_SALES = 'FIELD_SALES',
  SALES_REP = 'SALES_REP',
  SALES_OPS = 'SALES_OPS',
  BACKOFFICE = 'BACKOFFICE',
}
